import '../usageStatus.scss';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {formatUtcDateToLocalDateFormat, convertTimeCreditToPcBangPoint} from '../../../../util/timeUtils';
import Paginate from '../../../Common/Paginate';
import ProductBillingRecordsModal from './ProductBillingRecordsModal';
import {fetchProductBillingStatusesForCurrentUser, PURCHASE_STATES} from '../../../../actions/usageStatus.actions';
import {Table} from '../../../Common/PageComponents';

const stateToProps = state => {
  return {
    productBillingStatuses: state.usageStatus.productBillingStatuses.content,
    pageNumber: state.usageStatus.productBillingStatuses.pageNumber,
    totalItemCount: state.usageStatus.productBillingStatuses.totalItemCount,
    startDate: state.usageStatus.productBillingStatuses.startDate,
    endDate: state.usageStatus.productBillingStatuses.endDate,
  };
};

class ProductBillingHistoryList extends Component {
  _movePage(pageNumber) {
    this.props.dispatch(
      fetchProductBillingStatusesForCurrentUser(this.props.startDate, this.props.endDate, pageNumber)
    );
  }

  _renderProductBillingStatues(billingStatues) {
    if (billingStatues && billingStatues.length > 0) {
      return billingStatues.map(billingStatus => (
        <ProductBillingRecordsModal
          key={billingStatus.productEntitlementId}
          productEntitlementId={billingStatus.productEntitlementId}
        >
          <tr className="selectable">
            <td>{formatUtcDateToLocalDateFormat(billingStatus.purchaseDate)}</td>
            <td>{billingStatus.name}</td>
            <td>
              {convertTimeCreditToPcBangPoint(
                billingStatus.totalTimeCredit - billingStatus.remainingTimeCredit < 0
                  ? 0
                  : billingStatus.totalTimeCredit - billingStatus.remainingTimeCredit
              )}
            </td>
            <td>{convertTimeCreditToPcBangPoint(billingStatus.remainingTimeCredit)}</td>
            <td>{PURCHASE_STATES[billingStatus.purchaseState]}</td>
          </tr>
        </ProductBillingRecordsModal>
      ));
    }
    return (
      <tr>
        <td colSpan="5">사용내역이 없습니다.</td>
      </tr>
    );
  }

  render() {
    return (
      <div>
        <Table className="usage-status-table">
          <colgroup>
            <col style={{width: '90px'}} />
            <col style={{width: '156px'}} />
            <col style={{width: '112px'}} />
            <col style={{width: '115px'}} />
            <col style={{width: '90px'}} />
          </colgroup>
          <thead>
            <tr>
              <th>결제일</th>
              <th>구매 상품명</th>
              <th>소진 포인트</th>
              <th>잔여 포인트</th>
              <th className="end">상태</th>
            </tr>
          </thead>
          <tbody>{this._renderProductBillingStatues(this.props.productBillingStatuses)}</tbody>
        </Table>
        <Paginate
          currentPage={this.props.pageNumber}
          totalItemCount={this.props.totalItemCount}
          onChange={this._movePage.bind(this)}
        />
      </div>
    );
  }
}

export default connect(stateToProps)(ProductBillingHistoryList);
